/**

 * 提示语工具栏组件
 * 职责: 显示当前类型信息和操作按钮
 */
import React from 'react';
import { Button, Space, Tag, Typography } from 'antd';
import { SaveOutlined, ReloadOutlined, EnvironmentOutlined } from '@ant-design/icons';
import { PROMPT_TYPES } from '../constants/promptTypes';
import type { TemplateType } from '../../../types/ai-analysis-types';

const { Text } = Typography;

interface PromptToolbarProps {
    selectedType: TemplateType;
    saving: boolean;
    onSave: () => void;
    onReset: () => void;
}

export const PromptToolbar: React.FC<PromptToolbarProps> = ({
    selectedType,
    saving,
    onSave,
    onReset
}) => {
    const currentTypeInfo = PROMPT_TYPES.find(t => t.type === selectedType);

    return (
        <div style={{
            padding: '8px 16px',
            borderBottom: '1px solid #f0f0f0',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            background: '#fff',
            flexShrink: 0
        }}>
            <Space size="middle">
                <div style={{
                    width: 32,
                    height: 32,
                    borderRadius: 6,
                    background: `${currentTypeInfo?.color}15`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: currentTypeInfo?.color
                }}>
                    {currentTypeInfo?.icon}
                </div>
                <div>
                    <div style={{ fontWeight: 600, fontSize: 14 }}>{currentTypeInfo?.label}</div>
                    {currentTypeInfo?.path && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 4, marginTop: 2 }}>
                            <EnvironmentOutlined style={{ fontSize: 11, color: '#8c8c8c' }} />
                            <Text type="secondary" style={{ fontSize: 12 }}>
                                {currentTypeInfo.path}
                            </Text>
                        </div>
                    )}
                </div>
            </Space>

            <Space>
                <Button onClick={onReset} icon={<ReloadOutlined />} size="small">
                    恢复默认
                </Button>
                <Button
                    type="primary"
                    onClick={onSave}
                    icon={<SaveOutlined />}
                    loading={saving}
                    size="small"
                >
                    保存配置
                </Button>
            </Space>
        </div>
    );
};



